import React from 'react';
import {
  APP_CONTAINER_ROUTES,
  SHORT_PAY_CREDIT_REQUEST_ROUTES,
} from './routes';
import {
  AppContainerStackParams,
  ShortPayCreditRequestStackParams,
} from './types';
import { createStackNavigator } from '@react-navigation/stack';
import { CreditRequestInvoiceStoreProvider } from '@/stores/credit-request-invoice-store';
import { RouteProp, useRoute } from '@react-navigation/native';
import { ShortPayCreditRequestDetailsScreen } from '@/screens/payments/short-pay-credit-request-details-screen';
import { ShortPayCreditRequestItemsScreen } from '@/screens/payments/short-pay-credit-request-items-screen';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

type RouteProps = RouteProp<
  AppContainerStackParams,
  typeof APP_CONTAINER_ROUTES.ShortPayCreditRequestItems
>;

const Stack = createStackNavigator<ShortPayCreditRequestStackParams>();

export const ShortPayCreditRequestStack: React.FC = () => {
  const options = useDefaultStackScreenOptions();
  const route = useRoute<RouteProps>();
  const { onComplete, orderInvoiceUUID, subtotalInMicros, title } =
    route.params;
  return (
    <CreditRequestInvoiceStoreProvider>
      <Stack.Navigator
        initialRouteName={SHORT_PAY_CREDIT_REQUEST_ROUTES.Items}
        screenOptions={options}
      >
        <Stack.Screen
          component={ShortPayCreditRequestItemsScreen}
          initialParams={{
            onComplete,
            orderInvoiceUUID,
            subtotalInMicros,
            title,
          }}
          name={SHORT_PAY_CREDIT_REQUEST_ROUTES.Items}
        />
        <Stack.Screen
          component={ShortPayCreditRequestDetailsScreen}
          name={SHORT_PAY_CREDIT_REQUEST_ROUTES.Details}
        />
      </Stack.Navigator>
    </CreditRequestInvoiceStoreProvider>
  );
};
